//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.ProfileSystemBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../Features/Features.ShipDesign.PlaneListBuilderList.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../Features/Features.ShipDesign.EndCutBuilder.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../no/NXObjectList.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
import "../no/Weld.js";
let d=[[[0,"BuiltUpOffset",0,"Features.ShipDesign.BuiltUpOffsetBuilder",0],[1,"DefinitionCurves",0,"Section",0],[1,"DefinitionEquallySpacedCurve1",0,"Section",0],[1,"DefinitionEquallySpacedCurve2",0,"Section",0],[1,"DefinitionEquallySpacedNumber",0,"Expression",0],[1,"DefinitionEquallySpacedPlaneList",0,"Features.ShipDesign.PlaneListBuilderList",0],[0,"DefinitionMethod",1,0],[1,"DefinitionObjects",0,"SelectNXObjectList",0],[1,"DefinitionPlaneList",0,"Features.ShipDesign.PlaneListBuilderList",0],[1,"DefinitionProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"DefinitionRectangularCorner",1,"Point",0],[1,"DefinitionRectangularLength",0,"Expression",0],[0,"DefinitionRectangularLengthDirection",1,"Direction",0],[0,"DefinitionRectangularPlane",1,"Plane",0],[1,"DefinitionRectangularWidth",0,"Expression",0],[1,"EndCut",0,"Features.ShipDesign.EndCutBuilder",0],[0,"EndCutSplit",1,0],[0,"ErectionSplitSystem",1,0],[0,"IntersectionSplitSystem",1,0],[0,"PointProfileTolerance",1,0],[0,"ReparentFrecsReferencingSeamedObject",1,0],[0,"ScantlingSplitSystem",1,0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"ShipStructure",0,"SelectNXObjectList",0],[1,"StaggerDistanceList",0,"NXObjectList",0],[0,"StaggerShiftAlongMethod",1,0],[0,"StrakingSplitSystem",1,0],[0,"Type",1,0],[1,"WeldingCharacteristics",0,"Weld.CharacteristicsBuilder",0]],[[["plateOrProfile","numProfiles","profiles"],"GetAttachedProfiles",{},1,0],[["boundaryObject"],"RemoveObjectBoundary",{},1,0],[["boundaryCurve"],"RemoveCurveBoundary",{},1,0]],[]];
SPLM.Features.ShipDesign.SeamBuilder = class extends SPLM.Features.ShipDesign.ProfileSystemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SeamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SeamBuilder.Types = Object.freeze({
    "Scantling" : "Scantling", "Erection" : "Erection", "Straking" : "Straking", "Intersection" : "Intersection", "Eggbox" : "Eggbox"});

SPLM.Features.ShipDesign.SeamBuilder.DefinitionMethods = Object.freeze({
    "CurvesPlanesShip" : "CurvesPlanesShip", "EquallySpaced" : "EquallySpaced", "Rectangular" : "Rectangular"});

SPLM.Features.ShipDesign.SeamBuilder.StaggerShiftAlongMethods = Object.freeze({
    "Length" : "Length", "Width" : "Width"});

export default SPLM;